<script>
import {onMounted, ref} from 'vue';
import {WorkflowsRepository} from '@/services/workflows-repository';
import useLoading from '@/helpers/loading-effect';
import {useRouter} from 'vue-router';
import {useStore} from '@/helpers/store-effect';
import {useConfig} from '@/helpers/config-effect';
import {Workflow} from '@/models/workflow';
import useNotifications from "@/helpers/notify-effect";

export default {
  name: 'WorkflowsListing',
  template: '#workflows-listing-template',

  setup() {
    const {startLoading, stopLoading, isLoaded, isLoading} = useLoading();

    const config = useConfig();
    const router = useRouter();
    const store = useStore();
    const {notify} = useNotifications();
    const workflows = ref([]);

    const getAll = async () => {
      startLoading();
      workflows.value = await WorkflowsRepository.getWorkflows();
      stopLoading();
    };

    const duplicate = (workflow) => {
      const duplicatedWorkflow = workflow.duplicate();
      duplicatedWorkflow.name += ' (Copy)';

      store.workflow = duplicatedWorkflow;

      notify('Duplication', 'The workflow has been duplicated.', 'success')

      router.push({
        name: 'editor',
        params: {
          uid: duplicatedWorkflow.uid,
        },
      });
    };

    const trash = (workflow) => {
      if (confirm('Are you sure?')) {
        workflows.value.splice(workflows.value.indexOf(workflow), 1);
        WorkflowsRepository.trashWorkflow(workflow);
        notify('Removal', 'The workflow has been trashed.', 'success')
      }
    };

    const newWorkflowTemplate = new Workflow(config.workflow.defaults);

    const create = () => {
      store.workflow = newWorkflowTemplate.duplicate();

      router.push({
        name: 'editor',
        params: {
          uid: store.workflow.uid,
        },
      });
    };

    const download = (workflow) => {
      const blob = new Blob([JSON.stringify(workflow, null, 2)], {
        type: 'application/json'
      });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${workflow.name}.json`;

      link.click();
    };

    const toggleEnable = (workflow) => {
      workflow.enabled = !workflow.enabled;
      WorkflowsRepository.updateWorkflow(workflow);
      notify('State changed', workflow.enabled ? 'The workflow has been enabled.' : 'The workflow has been disabled', 'success')
    };

    onMounted(getAll);

    return {
      isLoaded,
      isLoading,
      workflows,
      create,
      duplicate,
      trash,
      download,
      toggleEnable,
    };
  },
};
</script>
